import { render } from "./EditProduct.vue?vue&type=template&id=1eeef9c4&ts=true"
import script from "./EditProduct.vue?vue&type=script&lang=ts"
export * from "./EditProduct.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\Hermelin\\hermelinshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__